import React, {memo} from "react";
import {Button, Divider, Space} from "antd";
import css from "./Impressum.less";
import i18n from "../../services/i18n";
import LayoutWithoutNavigation from "../LayoutWithoutNavigation/LayoutWithoutNavigation";
import LoginHeader from "../LoginHeader/LoginHeader";
import PageContentWrapper from "../PageContentWrapper/PageContentWrapper";
import LoginFooter from "../LoginFooter/LoginFooter";
import env from "../../../shared/const";
import {AlphaLoginText} from "../AlphaLoginText/AlphaLoginText";

const Impressum = () => {
    const openLoginPageWithDefaultTenant = () => {
        window.location.assign(`/${env.DEV_ORGANIZATION_ID}/login`);
    };

    // return <div className={css.root}>{"test"}</div>;
    return (
        <LayoutWithoutNavigation
            main={
                <div className={css.layoutWithoutNavigation}>
                    <LoginHeader
                        link={{
                            href: i18n.containers.topLevelPage.TopLevelPage.link(),
                            label: i18n.containers.topLevelPage.TopLevelPage.title(),
                        }}
                    />
                    <PageContentWrapper style={{margin: 0}}>
                        <Space
                            className={css.root}
                            direction="vertical"
                            size={1}
                        >
                            <h3>
                                {i18n.containers.topLevelPage.TopLevelPage.legalNotice.title()}
                            </h3>
                            <p>
                                {i18n.containers.topLevelPage.TopLevelPage.legalNotice.legalNotice()}
                            </p>
                            <b>
                                {i18n.containers.topLevelPage.TopLevelPage.legalNotice.companyName()}
                                <br />
                                {i18n.containers.topLevelPage.TopLevelPage.legalNotice.street()}
                                <br />
                                {i18n.containers.topLevelPage.TopLevelPage.legalNotice.zipCity()}
                            </b>
                            <Divider />
                            {i18n.containers.topLevelPage.TopLevelPage.legalNotice.contact.email()}
                            {i18n.containers.topLevelPage.TopLevelPage.legalNotice.contact.web()}
                            {i18n.containers.topLevelPage.TopLevelPage.legalNotice.contact.phone()}
                            <Divider />
                            {i18n.containers.topLevelPage.TopLevelPage.legalNotice.court()}
                            {i18n.containers.topLevelPage.TopLevelPage.legalNotice.registerNumber()}
                            {i18n.containers.topLevelPage.TopLevelPage.legalNotice.representative()}
                            {i18n.containers.topLevelPage.TopLevelPage.legalNotice.vatId()}
                            <Divider />
                            <h5>
                                {i18n.containers.topLevelPage.TopLevelPage.legalNotice.liabilityContent.headline()}
                            </h5>
                            <p>
                                {i18n.containers.topLevelPage.TopLevelPage.legalNotice.liabilityContent.paragraph1()}
                            </p>
                            <h5>
                                {i18n.containers.topLevelPage.TopLevelPage.legalNotice.liablityLinks.headline()}
                            </h5>
                            <p>
                                {i18n.containers.topLevelPage.TopLevelPage.legalNotice.liablityLinks.paragraph1()}
                            </p>
                            <h5>
                                {i18n.containers.topLevelPage.TopLevelPage.legalNotice.copyright.headline()}
                            </h5>
                            <p>
                                {i18n.containers.topLevelPage.TopLevelPage.legalNotice.copyright.paragraph1()}
                            </p>
                            {i18n.containers.topLevelPage.TopLevelPage.legalNotice.source()}
                        </Space>
                        {env.DEV_ORGANIZATION_ID && (
                            <LoginFooter>
                                <Button
                                    onClick={() => openLoginPageWithDefaultTenant()}
                                    className={css.loginButton}
                                >
                                    <AlphaLoginText size="small" />
                                </Button>
                            </LoginFooter>
                        )}
                    </PageContentWrapper>
                </div>
            }
        />
    );
};

export default memo(Impressum);
